<app-header #header title="Forms"></app-header>

<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header">
  <app-header-content ></app-header-content>
  <app-pagecontent  [path]="'forms'"></app-pagecontent>
  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>

  <ion-grid class="page-min-height">
    <div *ngIf="loaded && forms.length>0">
    <ion-row  *ngFor="let form of forms">
      <ion-col class="single-col-wider" >
        <ion-card class="card-shadow-7">
    
        
          <ion-grid>
              <ion-row>
                  <ion-col class="ion-padding">
                    <ion-label class="card-header-unique">{{form.title}}</ion-label>
                  </ion-col>
                </ion-row>
              <ion-row *ngIf="form.description">
                  <ion-col style="max-height: 29vh;overflow-y: auto;text-align: center;">
                      <ion-item >
                          
                              <ion-label class="ion-text-wrap card-text-regular">{{form.description}}</ion-label>
                          </ion-item>
                     
                  </ion-col>
              </ion-row>
              <ion-row>
                  <ion-col style="text-align: center;">
                     <ion-button (click)="openForm(form)"  color="primary"> {{ ('keys.data.form.form_open' | translate : {Default:'Open Form'}) ||
                      'Open Form' }}</ion-button>
                  </ion-col>
              </ion-row>
          </ion-grid>
      
        </ion-card>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="loaded && forms.length<1">
    <ion-card class="card-shadow-7">
        <ion-card-content style="text-align: center">
          <ion-label class="paragraph-regular">
          No forms are currently active.
          </ion-label>
        </ion-card-content>
      </ion-card>
</div>
  </ion-grid>
    

<ion-footer class="ion-no-border">
  <app-footer></app-footer>
</ion-footer>
</ion-content>
